import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { FaLock } from 'react-icons/fa';

const AdminModal = ({ show, onHide, onLogin, t }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const success = onLogin(password);
    if (success) {
      setPassword('');
      setError('');
    } else {
      setError(t.admin.error);
      setPassword('');
    }
  };

  const handleClose = () => {
    setPassword('');
    setError('');
    onHide();
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered 
      className="admin-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FaLock className="me-2" />
          {t.admin.login}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>{t.admin.password}</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              autoFocus
              required
            />
          </Form.Group>
          
          <div className="d-grid">
            <Button 
              type="submit" 
              variant="primary" 
              className="btn-primary-custom"
            >
              {t.admin.enter}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AdminModal;